import { providerType } from '@repo/shared/types';
export var isPragmaPromoted = function (merchantResponse) {
    var _a;
    return Boolean((_a = merchantResponse.config.find(function (config) { return config.provider === providerType.enum.pragma; })) === null || _a === void 0 ? void 0 : _a.default);
};
